import { isToday } from "date-fns";
import { AxiosInstance } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { extractError } from "utility/utils";
import { PaymentActivity } from "store/paymentActivity/paymentActivity-state";
import { AutoPayDTO, PaymentData } from "./payments-state";

import * as requestUrl from "../../constants/request";
import { createPaymentRequestData } from "./util";
import { addNotification } from "store/notification/notification-utils";
import { ThunkAPIConfig } from "store";

export type FetchAutoPay = typeof fetchAutoPay;

export const fetchAutoPay = createAsyncThunk<
  AutoPayDTO[],
  {
    request: AxiosInstance;
  }
>("autopay/fetchAutoPay", async ({ request }) => {
  const result = await request(requestUrl.FT_AUTO_PAY);
  return result.data;
});

export type SaveAutoPayInfo = typeof saveAutoPayInfo;

export const saveAutoPayInfo = createAsyncThunk<
  AutoPayDTO,
  {
    request: AxiosInstance;
    data: AutoPayDTO;
  }
>("autopay/saveAutoPayInfo", async ({ request, data: autopay }) => {
  const result = await request(requestUrl.FT_AUTO_PAY, {
    method: autopay.id ? "PUT" : "POST",
    data: autopay,
  });
  return result.data;
});

export type DeleteAutoPayInfo = typeof deleteAutoPayInfo;

export const deleteAutoPayInfo = createAsyncThunk<
  string,
  {
    request: AxiosInstance;
    data: string;
  }
>("autopay/deleteAutoPay", async ({ request, data: id }) => {
  await request(`${requestUrl.FT_AUTO_PAY}/${id}`, {
    method: "DELETE",
  });
  return id;
});

export type SubmitAndPay = typeof submitAndPay;

export const submitAndPay = createAsyncThunk<
  PaymentActivity,
  {
    request: AxiosInstance;
    data: PaymentData;
  },
  ThunkAPIConfig
>("autopay/submitAndPay", async ({ request, data: paymentData }, thunkApi) => {
  let enterActionId: number | null = null;
  if (!!(window as any).dtrum) {
    enterActionId = (window as any).dtrum.enterAction(
      "submit-and-pay"
    ) as number;
  }
  let scheduleFlag = false;
  if (paymentData.paymentDate && !isToday(new Date(paymentData.paymentDate))) {
    scheduleFlag = true;
  }
  const requestData = createPaymentRequestData(paymentData, scheduleFlag);

  const reqUrl = scheduleFlag
    ? requestUrl.FT_SCHEDULE_PAYMENT
    : requestUrl.FT_PROCESS_PAYMENT;

  try {
    const response = await request(reqUrl, {
      method: "post",
      data: requestData,
    });

    if (!!enterActionId && !!(window as any).dtrum) {
      console.log("leaving action ", enterActionId);
      (window as any).dtrum.leaveAction(enterActionId);
    }

    return response.data;
  } catch (e) {
    if (!!(window as any).dtrum) {
      (window as any).dtrum.reportError(e, enterActionId);
    }
    const errCode = extractError(e);
    const { isSlideOpen } = thunkApi.getState().common;
    addNotification(thunkApi.dispatch, isSlideOpen, {
      messages: errCode,
      type: "ERROR",
      closable: true,
    });
  }
  return thunkApi.rejectWithValue(null);
});
